import { render } from "./CecoList.vue?vue&type=template&id=5740605d&scoped=true"
import script from "./CecoList.vue?vue&type=script&lang=js"
export * from "./CecoList.vue?vue&type=script&lang=js"

import "./CecoList.vue?vue&type=style&index=0&id=5740605d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5740605d"]])

export default __exports__